import { render } from "./Mypayments.vue?vue&type=template&id=7dee8c32&scoped=true"
import script from "./Mypayments.vue?vue&type=script&lang=js"
export * from "./Mypayments.vue?vue&type=script&lang=js"

import "./Mypayments.vue?vue&type=style&index=0&id=7dee8c32&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7dee8c32"

export default script